import { createReducer, on } from '@ngrx/store';
import { PartnerCategory } from '../../models/partners.model';
import * as categoryActions from './categories-action';

export interface State {
  categories: PartnerCategory[];
  error: any;
}

export const initialState: State = {
  categories: [],
  error: null
};

export const categoryReducer = createReducer(
  initialState,
  on(categoryActions.loadCategories, state => {
    console.log('loadCategories action dispatched');
    return state;
  }),
  on(categoryActions.loadCategoriesSuccess, (state, action) => {
    console.log('loadCategoriesSuccess action dispatched', action.categories);
    return { ...state, categories: action.categories };
  }),
  on(categoryActions.loadCategoriesFailure, (state, action) => {
    console.log('loadCategoriesFailure action dispatched', action.error);
    return { ...state, error: action.error };
  })
);